<tellent-assistant-brand-mark class="mark" />
<span class="label">{{ label() }}</span>
